<script lang="ts" setup>
import './scss/Home.scss';
import './scss/ContratacionTerrestre.scss';
import { ref, computed, onMounted, ComponentPublicInstance, onBeforeUnmount } from 'vue';
import Footer from './components/Footer.vue';
import {
  findClientByTributaryCode,
  findCompaniesGPS,
  findZipCode,
  createOrUpdateClient,
  createPolicy,
  getPDFCoverage,
} from '../../../repositories/landing.repository';
import {
  validationRFC,
  evaluateNames,
  wrongDepartureDateTime,
  today,
} from '../../../helpers';
import storePolicy from '@store/policy';
import { useRouter } from 'vue-router';
import { BModal } from 'bootstrap-vue-next';
import WhatsappButton from './components/WhatsappButton.vue';
import moment from 'moment';
import { useI18n } from 'vue-i18n'
import CaptchaCloudflare from './components/CaptchaCloudflare.vue';

type CaptchaExpose = {
  reset: () => void
}

const { t } = useI18n();
const store = storePolicy();
const router = useRouter();
const refForm1 = ref<any>(null);
const refForm3 = ref<any>(null);
const inputsHidden = ref<boolean>(true);
const isOpenModal = ref<boolean>(false);
const loading = ref<boolean>(false);
const policyId = ref<number | null>(1);
const error = ref<string>('');
const companySelectedByParams = ref<{ nombre?: string; id: number } | null>(
  null,
);
const tokenCaptcha = ref<string | null>(null);
const captchaRef = ref<ComponentPublicInstance<CaptchaExpose> | null>(null)
const isSmallScreen = ref<boolean>(false);
const MOBILE_BREAKPOINT = 768;
const MOBILE_HALF_WIDTH_KEYS = new Set([
  'startDate',
  'startTime',
  'endDate',
  'endTime',
  'endForm',
  'faq-check',
  'docs-check',
  'private-check',
]);
const MOBILE_STOPS_KEYS = new Set(['stops', 'stop1', 'stop2', 'stop3']);

const updateScreenSize = () => {
  if (typeof window === 'undefined') return;
  isSmallScreen.value = window.innerWidth < MOBILE_BREAKPOINT;
};

onMounted(() => {
  updateScreenSize();
  window.addEventListener('resize', updateScreenSize);
  const { subAsset, product, ...rest } = store.data;

  // Validamos si hay alguna propiedad (excepto subAsset y product) que sea null
  const thereAreNullProps = Object.values(rest).some((valor) => valor === null);

  // Validamos la relación entre subAsset y product
  const isProductRequiredButMissing = subAsset !== null && product === null;

  if (thereAreNullProps || isProductRequiredButMissing) {
    router.push('/');
  }
});


onMounted(async () => {
  const comapaniesGPS = await findCompaniesGPS();
  fieldsForm2.value = fieldsForm2.value.map((field: any) => {
    if (field.key === 'companyGPSId') {
      field.options = comapaniesGPS;
      const { gpsCompany } = store.data.queryParams;
      const company = comapaniesGPS.find((company) => {
        return company.slug === gpsCompany;
      });
      if (company && gpsCompany) {
        companySelectedByParams.value = company;
        field.value = company;
        field.disabled = true;
        field.customClass =
          'multiselect--disabled .multiselect__select inputLanding';
      }
    }
    return field;
  });
});

onBeforeUnmount(() => {
  if (typeof window === 'undefined') return;
  window.removeEventListener('resize', updateScreenSize);
});

computed(() => fieldsForm3.value);

const fieldsForm1: any = ref([
  {
    key: 'rfc',
    title: t('landing.terrestre.contratacion_mx.rfc_del_cliente'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.rfc_del_cliente'),
    value: null,
    cols: 12,
    customClass: 'inputLanding text-uppercase',
    hidden: false,
    formatValue: (e: string) => e?.toUpperCase() ?? '',
    errors: [],
  },
]);

const fieldsForm2: any = ref([
  {
    key: 'tradeName',
    title: t('landing.terrestre.contratacion_mx.nombre_del_cliente'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.nombre_del_cliente'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
    formatValue: (e: string) => e?.toUpperCase() ?? '',
  },
  {
    key: 'email',
    title: t('landing.terrestre.contratacion_mx.email_del_cliente'),
    type: 'email',
    validations: {
      rules: {
        required: true,
        email: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
		 email: t('global.email_invalido'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.email_del_cliente'),
    value: store.data.email ?? null,
    cols: 12,
    customClass: 'inputLanding',
  },
  {
    key: 'phone1',
    title: t('landing.terrestre.contratacion_mx.telefono_del_cliente'),
    type: 'text',
    validations: {
      rules: {
        required: true,
        max: 12,
        min: 8,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.telefono_del_cliente'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
  },
  {
    key: 'companyGPSId',
    title: t('landing.terrestre.contratacion_mx.empresa_gps'),
    selectLabel: null,
    type: 'select',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    disabled: false,
    placeholder: t('landing.terrestre.contratacion_mx.empresa_gps'),
    value: null,
    cols: 12,
    customClass: 'inputSelect',
    options: [],
  },
  {
    key: 'address',
    title: t('landing.terrestre.contratacion_mx.direccion_del_cliente'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.direccion_del_cliente'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
  },
  {
    key: 'postCode',
    title: t('landing.terrestre.contratacion_mx.codigo_postal'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.codigo_postal_placeholder'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
    listenChange: true,
  },
  {
    key: 'colony',
    title: t('landing.terrestre.contratacion_mx.colonia'),
    selectLabel: null,
    type: 'select',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.colonia'),
    value: null,
    cols: 12,
    customClass: 'inputSelect',
    options: [],
  },
  {
    key: 'city',
    title: t('landing.terrestre.contratacion_mx.ciudad'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.ciudad'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
    disabled: true,
  },
  {
    key: 'state',
    title: t('landing.terrestre.contratacion_mx.estado'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.estado'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
    disabled: true,
  },
]);

const fieldsForm3: any = ref([
  { slot: true, key: 'title' },
  {
    key: 'assetId',
    title: t('landing.terrestre.contratacion_mx.tipo_de_mercancia'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.tipo_de_mercancia'),
    value: store.data?.asset?.nombre,
    cols: 12,
    customClass: 'inputLanding',
    disabled: true,
  },
  {
    key: 'indemnificationLimit',
    title: t('landing.terrestre.contratacion_mx.limite_de_indemnizacion'),
    type: 'number',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.limite_de_indemnizacion'),
    value: store.data.indemnificationLimit,
    cols: 6,
    customClass: 'inputLanding',
    disabled: true,
  },
  {
    key: 'indemnificationLimit-calc',
    title: t('landing.terrestre.contratacion_mx.precio'),
    type: 'text',
    value: `$${store.data.endPrice} + IVA`,
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.precio_mas_iva'),
    disabled: true,
    cols: 6,
    customClass: 'inputLanding',
  },
  {
    key: 'sourceCityZipCodeId',
    title: t('landing.terrestre.contratacion_mx.ciudad_de_origen'),
    type: 'number',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.codigo_postal_placeholder'),
    value: null,
    cols: 6,
    customClass: 'inputLanding',
    listenChange: true,
  },
  {
    key: 'sourceCityZipCodeIdCalc',
    title: t('landing.terrestre.contratacion_mx.ciudad_de_origen'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.ciudad_de_origen'),
    value: null,
    cols: 6,
    customClass: 'inputLanding',
    disabled: true,
  },
  {
    key: 'destinationCityZipCodeId',
    title: t('landing.terrestre.contratacion_mx.ciudad_de_destino_final'),
    type: 'number',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.codigo_postal_placeholder'),
    value: null,
    cols: 6,
    customClass: 'inputLanding',
    listenChange: true,
  },
  {
    key: 'destinationCityZipCodeIdCalc',
    title: t('landing.terrestre.contratacion_mx.ciudad_de_destino_final'),
    type: 'text',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    placeholder: t('landing.terrestre.contratacion_mx.ciudad_de_destino_final'),
    value: null,
    cols: 6,
    customClass: 'inputLanding',
    disabled: true,
  },
  {
    key: 'stops',
    title: t('landing.terrestre.contratacion_mx.paradas_intermedias'),
    selectLabel: null,
    type: 'select',
    placeholder: t('landing.terrestre.contratacion_mx.paradas_intermedias_placeholder'),
    value: null,
    cols: 3,
    customClass: 'inputSelect',
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    options: [
      { nombre: 'Si', id: 1 },
      { nombre: 'No', id: 0 },
    ],
    listenSelect: true,
  },
  {
    key: 'stop1',
    title: t('landing.terrestre.contratacion_mx.parada_1'),
    type: 'text',
    placeholder: t('landing.terrestre.contratacion_mx.parada_1'),
    value: null,
    cols: 3,
    disabled: true,
    validations: {
      rules: {
        required: false,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    customClass: 'inputLanding inputLanding--mt',
  },
  {
    key: 'stop2',
    title: t('landing.terrestre.contratacion_mx.parada_2'),
    type: 'text',
    placeholder: t('landing.terrestre.contratacion_mx.parada_2'),
    value: null,
    cols: 3,
    disabled: true,
    customClass: 'inputLanding inputLanding--mt',
  },
  {
    key: 'stop3',
    title: t('landing.terrestre.contratacion_mx.parada_3'),
    type: 'text',
    placeholder: t('landing.terrestre.contratacion_mx.parada_3'),
    value: null,
    cols: 3,
    disabled: true,
    customClass: 'inputLanding inputLanding--mt',
  },
  {
    key: 'startDate',
    title:  t('landing.terrestre.contratacion_mx.fecha_inicio_viaje'),
    type: 'datetime',
    placeholder:  t('landing.terrestre.contratacion_mx.fecha_inicio_viaje'),
    value: null,
	  enableTimePicker: false,
    format: 'dd/MM/yyyy',
	  modelType: 'yyyy-MM-dd',
    min: new Date(),
    autoApply: true,
    listenChange: true,
    cols: 6,
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    customClass: 'inputLanding inputDateTime',
  },
  {
    key: 'startTime',
    title: t('landing.terrestre.contratacion_mx.hora_inicio_viaje'),
    type: 'time',
    placeholder: t('landing.terrestre.contratacion_mx.hora_inicio_viaje'),
    value: null,
    cols: 6,
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    customClass: 'inputLanding',
    listenFocus: true,
  },
  {
    key: 'endDate',
    title: t('landing.terrestre.contratacion_mx.fecha_fin_viaje'),
    type: 'datetime',
    placeholder: t('landing.terrestre.contratacion_mx.fecha_fin_viaje'),
    value: null,
    cols: 6,
    enableTimePicker: false,
    format: 'dd/MM/yyyy',
	  modelType: 'yyyy-MM-dd',
    min: new Date(),
    disabled: true,
    autoApply: true,
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    customClass: 'inputLanding inputDateTime',
  },
  {
    key: 'endTime',
    title: t('landing.terrestre.contratacion_mx.hora_fin_viaje'),
    type: 'time',
    placeholder: t('landing.terrestre.contratacion_mx.hora_fin_viaje'),
    value: null,
    cols: 6,
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    customClass: 'inputLanding',
  },
  {
    key: 'documentDescription',
    title: t('landing.terrestre.contratacion_mx.documentos_del_viaje'),
    type: 'text',
    placeholder: t('landing.terrestre.contratacion_mx.documentos_del_viaje'),
    value: null,
    cols: 6,
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    customClass: 'inputLanding',
  },
  {
    key: 'document',
    title: t('landing.terrestre.contratacion_mx.adjuntar_documentos'),
    type: 'file',
    placeholder: t('landing.terrestre.contratacion_mx.adjuntar_documentos'),
    value: null,
    cols: 6,
    hidden: false,
    customClass: 'inputFile',
  },
  {
    key: 'truckPlate',
    title: t('landing.terrestre.contratacion_mx.placa_tractor'),
    type: 'text',
    placeholder: t('landing.terrestre.contratacion_mx.placa_tractor'),
    value: null,
    cols: 4,
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    customClass: 'inputLanding',
  },
  {
    key: 'box-trailer',
    title: t('landing.terrestre.contratacion_mx.caja_de_carga'),
    selectLabel: null,
    type: 'select',
    placeholder: t('landing.terrestre.contratacion_mx.caja_de_carga'),
    value: null,
    cols: 4,
    options: [
      { nombre: 'Si', id: 1 },
      { nombre: 'No', id: 0 },
    ],
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    hidden: false,
    customClass: 'inputSelect',
    listenSelect: true,
  },
  {
    key: 'trailerPlate',
    title: t('landing.terrestre.contratacion_mx.placa_caja'),
    type: 'text',
    placeholder: t('landing.terrestre.contratacion_mx.placa_caja'),
    value: null,
    cols: 4,
    customClass: 'inputLanding',
    validations: {
      rules: {
        required: false,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    disabled: true,
  },
  {
    key: 'driverName',
    title: t('landing.terrestre.contratacion_mx.nombre_del_conductor'),
    type: 'text',
    placeholder: t('landing.terrestre.contratacion_mx.nombre_del_conductor'),
    value: null,
    cols: 12,
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    customClass: 'inputLanding',
  },
  {
    key: 'driverCellphone',
    title: t('landing.terrestre.contratacion_mx.movil_del_conductor'),
    type: 'text',
    placeholder: t('landing.terrestre.contratacion_mx.movil_del_conductor'),
    value: null,
    cols: 12,
    validations: {
      rules: {
        required: true,
        max: 12,
        min: 8,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    customClass: 'inputLanding',
  },
  {
    key: 'driverEmail',
    title: t('landing.terrestre.contratacion_mx.email_del_conductor'),
    type: 'email',
    placeholder: t('landing.terrestre.contratacion_mx.email_del_conductor'),
    value: null,
    cols: 12,
    validations: {
      rules: {
		required: true,
        email: true,
      },
	  messages: {
		 email: t('global.email_invalido'),
		 required: t('global.es_obligatorio'),
	  },
    },
    hidden: false,
    customClass: 'inputLanding',
  },
  { slot: true, key: 'endForm', cols: 12 },
  {
    key: 'auth-check',
    type: 'checkbox',
    value: null,
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    slotContent: `<p class="text-white">${t('landing.terrestre.contratacion_mx.termino1')}</p>`,
  },
  {
    key: 'faq-check',
    type: 'checkbox',
    value: null,
    cols: 12,
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    slotContent: `<p class="text-white">${t('landing.terrestre.contratacion_mx.acepto_los')}
                    <a
                      target="_blank"
                      href="https://www.chubb.com/content/dam/chubb-sites/chubb-com/mx-es/condiciones-generales/global/documents/pdf/ad33-aba-d-transporte-de-carga-especifica.pdf"
                      class="text-black"
                    >
                      ${t('landing.terrestre.contratacion_mx.terminos_y_condiciones')}
                    </a>
                  </p>`,
  },
  {
    key: 'docs-check',
    type: 'checkbox',
    value: null,
    cols: 12,
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    slotContent: `<p class="text-white">${t('landing.terrestre.contratacion_mx.termino2')}</p>`,
  },
  {
    key: 'private-check',
    type: 'checkbox',
    value: null,
    cols: 12,
    validations: {
      rules: {
        required: true,
      },
	  messages: {
		 required: t('global.es_obligatorio'),
	  },
    },
    slotContent: `<p class="text-white">${t('landing.terrestre.contratacion_mx.termino3')}
                  <a href="https://www.chubb.com/content/dam/chubb-sites/chubb-com/mx-es/footer/privacy-notices/documents/pdf/aviso-de-privacidad-asegurados-chubb-seguros-mexico.pdf" target="_blank" class="text-black">${t('landing.terrestre.contratacion_mx.aqui')}</a></p>`,
  },
]);

const responsiveFieldsForm1 = computed(() =>
  fieldsForm1.value.map((field: any) => ({
    ...field,
    cols:
      isSmallScreen.value && MOBILE_STOPS_KEYS.has(field.key)
        ? 6
        : isSmallScreen.value && !MOBILE_HALF_WIDTH_KEYS.has(field.key)
        ? 12
        : field.cols,
  })),
);

const responsiveFieldsForm2 = computed(() =>
  fieldsForm2.value.map((field: any) => ({
    ...field,
    cols:
      isSmallScreen.value && MOBILE_STOPS_KEYS.has(field.key)
        ? 6
        : isSmallScreen.value && !MOBILE_HALF_WIDTH_KEYS.has(field.key)
        ? 12
        : field.cols,
  })),
);

const responsiveFieldsForm3 = computed(() =>
  fieldsForm3.value.map((field: any) => ({
    ...field,
    cols:
      isSmallScreen.value && MOBILE_STOPS_KEYS.has(field.key)
        ? 6
        : isSmallScreen.value && !MOBILE_HALF_WIDTH_KEYS.has(field.key)
        ? 12
        : field.cols,
  })),
);

const handleOnSubmitRFC = async (e: any) => {
  const isValidRfc = validationRFC(e.items.rfc);
  if (!e.isFormValid || !isValidRfc) {
    return (fieldsForm1.value[0].errors = ['rfc es invalido']);
  }
  const { locations, client } = await findClientByTributaryCode(e.items.rfc);

  if (client) {
    store.setProp({ key: 'client', value: client });
  }

  if (locations && client) {
    const updatesClientInputs = [
      { key: 'tradeName', value: client.tradeName },
      { key: 'phone1', value: client.phone1 },
      {
        key: 'companyGPSId',
        value: {
          id: companySelectedByParams.value?.id ?? client.companyGPS.id,
          nombre:
            companySelectedByParams.value?.nombre ??
            client.companyGPS.description,
        },
      },
      { key: 'address', value: client.address },
      { key: 'postCode', value: client.postCode },
      {
        key: 'colony',
        options: locations,
        value: {
          id: client.neighborhood.id,
          nombre: client.neighborhood.description,
        },
      },
      { key: 'city', value: client.city.description },
      { key: 'state', value: client.state.description },
    ];

    updateFieldsInArray(fieldsForm2.value, updatesClientInputs, null);
  }
  fieldsForm1.value.find((field: any) => field.key === 'rfc').disabled = true;

  inputsHidden.value = false;

  if (!client) {
    store.setProp({ key: 'client', value: { rfc: e.items.rfc } });
  }
};

const handleChange = async (e: any) => {
  if (e.value.length < 4 || e.value.length > 7) return;

  const location = await findZipCode(e.value, false);

  const storeDate = store.data;

  // Si no existe el codigo postal dejamos una bandera en el input
  if (!location.data?.length) {
    if (e.input.key === 'sourceCityZipCodeId') {
      store.setProp({
        key: 'data',
        value: { ...storeDate, sourceCityZipCodeId: null },
      });
      fieldsForm3.value.find(
        (field: any) => field.key === 'sourceCityZipCodeIdCalc',
      ).value = 'CP INVALIDO';
    } else {
      store.setProp({
        key: 'data',
        value: { ...storeDate, destinationCityZipCodeId: null },
      });
      fieldsForm3.value.find(
        (field: any) => field.key === 'destinationCityZipCodeIdCalc',
      ).value = 'CP INVALIDO';
    }
    return;
  }

  // se estable el nombre de la locacion en el input
  if (e.input.key === 'sourceCityZipCodeId') {
    store.setProp({
      key: 'data',
      value: { ...storeDate, sourceCityZipCodeId: location.data[0].id },
    });
    fieldsForm3.value.find(
      (field: any) => field.key === 'sourceCityZipCodeIdCalc',
    ).value = location.data[0].MunicipioNombre;
  } else {
    store.setProp({
      key: 'data',
      value: { ...storeDate, destinationCityZipCodeId: location.data[0].id },
    });
    fieldsForm3.value.find(
      (field: any) => field.key === 'destinationCityZipCodeIdCalc',
    ).value = location.data[0].MunicipioNombre;
  }
};

const handleSelectChange = (e: any) => {
  const updateFields = [];

  if (e.input.key === 'box-trailer') {
    updateFields.push(
      { key: 'trailerPlate', disabled: !e.value.id },
      { key: 'trailerPlate', 'validations.rules.required': e.value.id },
    );
  } else {
    updateFields.push(
      { key: 'stop1', disabled: !e.value.id },
      { key: 'stop1', 'validations.rules.required': e.value.id },
      { key: 'stop2', disabled: !e.value.id },
      { key: 'stop3', disabled: !e.value.id },
    );
  }

  updateFieldsInArray(fieldsForm3.value, updateFields, null);
};

const handleChangeColony = async (e: any) => {
  const formProps = await refForm1.value.getValues();

  const location = await findZipCode(e.value, false);

  if (!location?.data?.length) return;

  const locations = location.data.map((loc: any) => ({
    nombre: loc.ColoniaDsc,
    id: loc.id,
  }));

  const preservedValues = {
    tradeName: formProps.items.tradeName,
    email: formProps.items.email,
    phone1: formProps.items.phone1,
    companyGPSId: formProps.items.companyGPSId,
    address: formProps.items.address,
  };

  updateFieldsInArray(
    fieldsForm2.value,
    [
      { key: 'colony', options: locations, value: { id: null } },
      { key: 'state', value: location.data[0].EstadoNombre },
      { key: 'city', value: location.data[0].MunicipioNombre },
      { key: 'postCode', value: location.data[0].code },
    ],
    preservedValues,
  );

  const values = {
    country: { id: location.data[0].PaisID },
    city: { id: location.data[0].MunicipioId },
    neighborhood: { id: location.data[0].ColoniaId },
    postCode: location.data[0].code,
    rfc: store.client.rfc,
    state: { id: location.data[0].EstadoID },
  };

  store.setProp({
    key: 'client',
    value: { ...store.client, ...values },
  });
};

const updateFieldsInArray = (
  array: any,
  updates: any,
  preservedValues: any,
) => {
  for (const update of updates) {
    const field = array.find((field: any) => field.key === update.key);
    if (field) {
      if ('value' in update) {
        field.value = update.value;
      }
      if ('options' in update) {
        field.options = update.options;
      }
      if ('disabled' in update) {
        field.disabled = update.disabled;
      }
    }
  }

  if (preservedValues) {
    for (const key in preservedValues) {
      const field = array.find((field: any) => field.key === key);
      if (field) {
        field.value = preservedValues[key];
      }
    }
  }
};

const handleOnSubmitPolicies = async ({ items, isFormValid }: any) => {
//   if(loading.value) return;

  const { items: itemsForm1, isFormValid: isFormValidForm1 } =
    await refForm1.value.getValues();

  if (!tokenCaptcha.value) {
    return (error.value = t('landing.terrestre.contratacion_mx.por_favor_verifica_el_recaptcha'));
  }

  if (!isFormValidForm1) {
    return (error.value = t('landing.terrestre.contratacion_mx.el_formulario_debe_estar_completo'));
  }
  if (!isFormValid) {
    return (error.value = t('landing.terrestre.contratacion_mx.el_formulario_debe_estar_completo'));
  }

  const { address, companyGPSId, email, phone1, tradeName } = itemsForm1;

  const {
    indemnificationLimit,
    truckPlate,
    trailerPlate,
    driverName,
    documentDescription,
    driverCellphone,
    driverEmail,
    startDate,
    endDate,
    startTime,
    endTime,
    stops,
    stop1,
    stop2,
    stop3,
    destinationCityZipCodeIdCalc,
    sourceCityZipCodeIdCalc,
    document,
  } = items;

  const isOkDepartureDateTime = wrongDepartureDateTime(
    startDate,
    startTime,
    'mx',
  );

  if (isOkDepartureDateTime) {
    return (error.value = t('landing.terrestre.contratacion_mx.la_hora_de_salida_no_puede_ser_menor'));
  }

  if (
    destinationCityZipCodeIdCalc === 'CP INVALIDO' ||
    sourceCityZipCodeIdCalc === 'CP INVALIDO'
  ) {
    return (error.value = t('landing.terrestre.contratacion_mx.codigo_postal_no_valido'));
  }

  const validationRfcAndName = evaluateNames(store.client.rfc, tradeName);

  const {
    clientMotherSurname,
    clientFathersSurname,
    clientNames,
    clientBirthOrConstDate,
    taxIdVerificationCode,
    namesError,
    isClientAPhysicalPerson,
  } = validationRfcAndName;

  if (namesError) {
    return (error.value = t('landing.terrestre.contratacion_mx.ingrese_su_nombre_completo_seguido_de'));
  }

  const travelStartDate = new Date(`${startDate}T${startTime}`);
  const travelEndDate = new Date(`${endDate}T${endTime}`);
  const fechaISOstart = moment(travelStartDate).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
  const fechaISOend = moment(travelEndDate).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
  const start = moment(fechaISOstart);
  const end = moment(fechaISOend);
  if (end.isBefore(start)) {
 	return (error.value = 'La fecha de fin no puede ser menor a la de inicio');
  }

  try {
    loading.value = true;

    const createOrUpdateClientData = {
      isClientAPhysicalPerson,
      clientMotherSurname,
      clientFathersSurname,
      clientNames,
      clientBirthOrConstDate,
      taxIdVerificationCode,
      namesError,
      address,
      email,
      tradeName,
      phone1,
      countryId: store.client.country.id,
      cityId: store.client.city.id,
      neighborhoodId: store.client.neighborhood.id,
      postCode: store.client.postCode,
      rfc: store.client.rfc,
      stateId: store.client.state.id,
      companyGPSId: store.client?.companyGPS?.id ?? companyGPSId.id,
      urlDomain: window.location.origin,
    };

    const client = await createOrUpdateClient(
      store.client.id,
      createOrUpdateClientData,
      'MX',
    );
    store.setProp({
      key: 'client',
      value: { ...store.client, id: client.data.client.id },
    });


    const assetId = store.data.asset.id;
    const subAssetId = store.data.subAsset?.id ?? null;
    const productId = store.data.product?.id ?? null;

    const createPolicyData = {
      tradeName,
      rfc: store.client.rfc,
      assetId,
	  subAssetId,
	  productId,
      indemnificationLimit,
      sourceCityZipCodeId: store.data.sourceCityZipCodeId,
      destinationCityZipCodeId: store.data.destinationCityZipCodeId,
      companyGPSId: companyGPSId.id,
      truckPlate,
      trailerPlate,
      driverName,
      documentDescription,
      driverCellphone,
      driverEmail,
      travelStartDate: fechaISOstart,
      travelEndDate: fechaISOend,
      hasStops: stops.nombre,
      stop1,
      stop2,
      stop3,
      document: document?.length ? document[0].image : null,
      token: tokenCaptcha.value,
    };

    const {data} = await createPolicy(
      client.data.client.id,
      client.data.manager.id,
      createPolicyData,
    );

    loading.value = false;

    if (data) {
      policyId.value = data.id;
      isOpenModal.value = true;
    }
  } catch (e: any) {
    error.value = e.message ?? t('global.ocurrio_un_error');
    loading.value = false;
  }finally{
	 captchaRef.value?.reset()
  }
};

const hideModal = () => {
  isOpenModal.value = false;
  return router.push('/');
};

const handleGetPDFCoverage = () => {
  getPDFCoverage(policyId.value);
};

const handleTokenCaptcha = (token: string) => {
  tokenCaptcha.value = token;
};

const handleOnExpired = () => {
  tokenCaptcha.value = null;
};

const handleAllowEndDate = async(e: any) => {
    fieldsForm3.value.find((field: any) => field.key === 'endDate').disabled = e.value ? false : true;
    fieldsForm3.value.find((field: any) => field.key === 'endDate').min = new Date(`${e.value}T00:00:00`);
	  await refForm3.value.setValue({ key: 'endDate', value: null });
}
</script>

<template>
  <h1 class="landing__title">{{ t('landing.terrestre.contratacion_mx.seguro_de_mercancias_por_trayecto') }}</h1>
  <h2 class="landing__subtitle">{{ t('landing.terrestre.contratacion_mx.ya_falta_menos') }}</h2>
  <h2 class="landing__subtitle">{{ t('landing.terrestre.contratacion_mx.ayudanos_completando') }}</h2>
  <div class="contratacion">
    <div class="contratacion__container">
      <h2 class="text-center text-white">{{ t('landing.terrestre.contratacion_mx.datos_del_cliente') }}</h2>
      <Form
        ref="refTableForm"
        :inputs="responsiveFieldsForm1"
        @onSubmit="handleOnSubmitRFC"
        @change="handleChangeColony"
      >
        <template #buttons>
          <div class="d-flex" v-if="inputsHidden">
            <CButton
              class="p-4 w-100 my-2 px-2"
              background="background-green"
              style="font-size: 1rem"
            >
              <template #content>{{ t('landing.terrestre.contratacion_mx.comprobar_rfc') }}</template>
            </CButton>
          </div>
        </template>
      </Form>
      <template v-if="!inputsHidden">
        <Form
          ref="refForm1"
          :inputs="responsiveFieldsForm2"
          @change="handleChangeColony"
        ></Form>
        <Form
          ref="refForm3"
          :inputs="responsiveFieldsForm3"
          @onSubmit="handleOnSubmitPolicies"
          @change="handleChange"
          @datePicker="handleAllowEndDate"
          @select="handleSelectChange"
        >
          <template #title>
            <h2 class="text-center text-white mt-5">{{ t('landing.terrestre.contratacion_mx.datos_del_viaje') }}</h2>
          </template>
          <template #endForm>
            <h2 class="text-center text-white mt-2 fs-5">
				{{ t('landing.terrestre.contratacion_mx.seguro_de_propiedad') }}
            </h2>
          </template>

          <template #buttons>
            <p v-if="error" class="text-danger-emphasis mt-3">{{ error }}</p>
			<CaptchaCloudflare
				ref="captchaRef"
				@verified="handleTokenCaptcha"
				@expired="handleOnExpired"
			/>
            <div class="d-flex">
              <CButton
                class="p-4 w-100 my-2 px-2"
                background="background-green"
                style="font-size: 1.5rem"
              >
                <template #content>
                  <div>
                    <BSpinner v-if="loading" />
                    <span v-else>{{ t('landing.terrestre.contratacion_mx.contratar_el_seguro') }}</span>
                  </div>
                </template>
              </CButton>
            </div>
          </template>
        </Form>
      </template>
    </div>
  </div>
  <Footer />
  <WhatsappButton />
  <BModal
    :modelValue="isOpenModal"
    hide-footer
    static
    @hide="hideModal"
    size="lg"
    v-if="policyId"
  >
    <h3>{{ t('landing.paqueteria.contratacion_paqueteria.felicitaciones_poliza_generada') }}</h3>
    <p>{{ t('landing.paqueteria.contratacion_paqueteria.numero_transaccion') }} {{ policyId }}/{{ new Date().getFullYear() }}</p>
    <p>
		{{ t('landing.paqueteria.contratacion_paqueteria.carta_cobertura_enviada') }}
      <a class="underline-link cursor-pointer" @click="handleGetPDFCoverage"
        >{{ t('landing.paqueteria.contratacion_paqueteria.aqui') }}</a
      >
    </p>
    <p>
		{{ t('landing.paqueteria.contratacion_paqueteria.realiza_pago_para_activar') }}
    </p>
    <h3>{{ t('landing.paqueteria.contratacion_paqueteria.datos_bancarios_titulo') }}</h3>
    <ul>
      <li>{{ t('landing.paqueteria.contratacion_paqueteria.banco_nombre') }}</li>
      <li>{{ t('landing.paqueteria.contratacion_paqueteria.banco_entidad') }}</li>
      <li>{{ t('landing.paqueteria.contratacion_paqueteria.banco_cuenta') }}</li>
      <li>{{ t('landing.paqueteria.contratacion_paqueteria.banco_clave') }}</li>
      <li>{{ t('landing.paqueteria.contratacion_paqueteria.banco_referencia') }} {{ policyId }}/{{ new Date().getFullYear() }}</li>
    </ul>
    <p style="color: red">
		{{ t('landing.paqueteria.contratacion_paqueteria.atencion_seguro_validez') }}
    </p>
    <p>
		{{ t('landing.paqueteria.contratacion_paqueteria.ayuda_pago_contacto') }}
      <a class="underline-link">+52 55 4619 4648</a>
    </p>
  </BModal>
</template>
